<ng-content></ng-content>
<button
    class="hamburger"
    (click)="toggleMenu.emit()"
    type="button"
    aria-label="menu"
    aria-haspopup="true"
    [attr.aria-expanded]="isOpen() ? 'true' : 'false'"
    data-testid="header-hamburger-button"
>
    <asn-icon class="hamburger__spring" name="hamburger-menu" size="large" title="Menu"></asn-icon>
</button>
